<div
  class="list-row tw-flex tw-items-center tw-gap-3"
  [ngClass]="classes"
  (click)="toggle()">
  <!-- Checkbox Column -->
  <button
    type="button"
    class="checkbox checkbox-column"
    [attr.aria-label]="student.firstName + ' ' + student.lastName"
    [attr.data-analytics]="'tools-myclass-click-student-card'"
    [attr.data-test]="'tools-myclass-click-student-card'">
    <div class="card-checkbox">
      <mg-form-checkbox [checked]="selected"></mg-form-checkbox>
    </div>
  </button>

  <!-- Avatar Column -->
  <div
    *ngIf="hidePicture === false"
    class="list-avatar">
    <div
      *ngIf="student.filename"
      class="profile-picture"
      [mgStudentPicture]="student.filename"></div>
    <mg-avatar
      *ngIf="!student.filename && student.profileImageUrl"
      [src]="student.profileImageUrl">
    </mg-avatar>
    <div
      *ngIf="!student.filename && !student.profileImageUrl"
      class="profile-picture"
      [style.background-image]="'url(/assets/student-id/placeholder-profile-pic.png)'"></div>
  </div>

  <!-- First Name Column -->
  <mg-text
    class="first-name-column"
    variant="body-md"
    [numberOfLines]="1">
    {{ student.firstName }}
  </mg-text>

  <!-- Last Name Column -->
  <mg-text
    class="last-name-column"
    variant="body-md"
    [numberOfLines]="1">
    {{ student.lastName }}
  </mg-text>

  <div class="tw-flex tw-items-center tw-grow tw-gap-0.5">
    <!-- Spacer -->
    <div class="spacer-column"></div>
    <!-- Hallpass Column -->
    <div class="hallpass-column tw-flex tw-items-center tw-gap-1">
      <ng-container *ngIf="hallPass && PASS_STATUS_TO_TYPE[hallPass.status.state]">
        <ng-container
          *ngIf="
            hallPass?.status.state === HallPassStatus.ACTIVE ||
            hallPass?.status.state === HallPassStatus.OVERDUE ||
            hallPass?.status.state === HallPassStatus.PENDING_APPROVAL
          ">
          <mg-icon
            matTooltipClass="mg-tooltip"
            [matTooltip]="hallPass.type?.name"
            [iconName]="hallPass.type?.bannerHash"
            [style.color]="hallPass.type?.color">
          </mg-icon>
        </ng-container>
        <ng-container
          *ngIf="
            hallPass
              | countdown
                : (recentlyEndedSetting$ | async)
                : (manuallyEndedPassesSetting$ | async)
                : myClassHallPassService.timeTicker$
                : hallPass.type?.manuallyEndPass
              | async as countdown;
            else loadingTemplate
          ">
          <ng-container *ngTemplateOutlet="hallpassPillTemplate; context: { countdown: countdown }"> </ng-container>

          <ng-container
            *ngIf="
              HallPassStatus.PENDING_APPROVAL === hallPass.status.state &&
              (('HALL_PASS_TYPE_MANAGE' | hasPermission) || authHash === hallPass.authorPersonView?.personHash)
            ">
            <div
              class="tt-pill"
              [attr.data-analytics]="'tools-myclass-click-pill-deny'"
              [attr.data-test]="'tools-myclass-click-pill-deny'"
              (click)="$event.stopPropagation(); onHallPassActionClicked('deny', { skipConfirmation: true })">
              <mg-icon
                class="deny"
                iconName="mg-cross">
              </mg-icon>
            </div>
            <div
              class="tt-pill"
              [attr.data-analytics]="'tools-myclass-click-pill-approve'"
              [attr.data-test]="'tools-myclass-click-pill-approve'"
              (click)="$event.stopPropagation(); onHallPassActionClicked('approve', { skipConfirmation: true })">
              <mg-icon
                class="approve"
                iconName="mg-checkmark">
              </mg-icon>
            </div>
          </ng-container>
          <mg-btn
            *ngIf="HallPassStatus.ACTIVE === hallPass.status.state || HallPassStatus.OVERDUE === hallPass.status.state"
            class="tw-flex"
            variant="text"
            size="xsmall"
            id="tools-myclass-click-pill-end"
            (pressed)="onHallPassActionClicked('end', { skipConfirmation: true })">
            End
          </mg-btn>
        </ng-container>
      </ng-container>
    </div>

    <!-- Check In Column -->
    <div
      *ngIf="showCheckIn"
      class="checkin-column tw-flex">
      <ng-container
        *ngIf="isCheckInEnabled$ | async | showCheckIns: showCheckIn:student:(pastCheckIns$ | async)"
        [ngTemplateOutlet]="checkinPillTemplate"
        [ngTemplateOutletContext]="{ checkIns: (pastCheckIns$ | async) }">
      </ng-container>
    </div>

    <!-- FlexTime Column -->
    <div
      *ngIf="showFlexTime"
      class="flextime-pill-column tw-flex">
      <ng-container
        *ngIf="upcomingPeriod"
        [ngTemplateOutlet]="flextimePillTemplate">
      </ng-container>
    </div>

    <div
      *ngIf="showFlexTime"
      class="flextime-name-column tw-flex">
      <mg-text
        class="flextime-activity-title"
        variant="body-xs"
        matTooltipClass="mg-tooltip"
        [matTooltip]="upcomingFlexActivity?.flexTimeActivity?.name || ''"
        [numberOfLines]="1">
        {{ upcomingFlexActivity?.flexTimeActivity?.name || '' }}
      </mg-text>
    </div>

    <!-- Praise Column -->
    <div
      *ngIf="showBehaviors && praisesAssigned"
      class="praise-column tw-flex">
      <ng-container *ngTemplateOutlet="praisePillTemplate"> </ng-container>
    </div>

    <!-- Guidance Column -->
    <div
      *ngIf="showBehaviors && guidancesAssigned"
      class="guidance-column tw-flex">
      <ng-container *ngTemplateOutlet="guidancePillTemplate"> </ng-container>
    </div>

    <!-- Profile Column -->
    <div class="profile-column">
      <mg-btn
        *ngIf="canViewProfile; else idTemplate"
        class="card-student-id"
        size="small"
        variant="icon-secondary"
        icon="mg-role"
        iconSet="minga"
        tooltip="Profile"
        id="tools-myclass-click-view-profile"
        [attr.aria-label]="'Nagivate to student profile'"
        (click)="$event.stopPropagation()"
        target="_blank"
        [href]="getProfileRoute(student.personHash)">
      </mg-btn>
      <ng-template #idTemplate>
        <mg-btn
          [attr.aria-label]="'Nagivate to student id'"
          class="card-student-id"
          size="small"
          variant="icon-secondary"
          icon="mg-id-menu-o"
          iconSet="minga"
          (click)="$event.stopPropagation()"
          [routerLink]="getStudentIdRoute(student.personHash)">
        </mg-btn>
      </ng-template>
    </div>
  </div>
</div>

<!-- Hallpass Pill Template -->
<ng-template
  #hallpassPillTemplate
  let-countdown="countdown">
  <mg-tt-pill
    [class.muted-pill]="hallPass.status.state === HallPassStatus.ENDED"
    [attr.aria-label]="'Active Hall Passes'"
    [type]="
      selected && hallPass.status.state === HallPassStatus.ACTIVE
        ? 'selected'
        : PASS_STATUS_TO_TYPE[hallPass.status.state]
    "
    icon="mg-away"
    [text]="
      hallPass.status.state === HallPassStatus.ACTIVE || hallPass.status.state === HallPassStatus.OVERDUE
        ? '' + countdown
        : ''
    "
    [id]="'tools-myclass-click-pill-hp'"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="hallpass">
    <mat-menu
      #hallpass="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div
          class="popup-wrap large"
          fxLayout="column"
          fxLayoutGap="4px">
          <mg-text
            variant="label-md-secondary"
            element="p">
            {{ hallPass.status.state }} Hall Pass
          </mg-text>
          <mg-text
            variant="label-md"
            element="p">
            {{ hallPass.type?.name }}
          </mg-text>

          <ng-container *ngIf="hallPass.status.state === HallPassStatus.ENDED; else timer">
            <mg-text
              variant="label-md"
              element="p">
              {{ hallPass.status.end | date: 'hh:mm a' }}
            </mg-text>
          </ng-container>
          <ng-template #timer>
            <ng-container *ngIf="countdown; else loadingTemplate">
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="2px">
                <mg-icon
                  *ngIf="showIcon() && hallPass.status.state === HallPassStatus.ACTIVE"
                  class="auto-end-icon"
                  iconName="mg-auto-end">
                </mg-icon>
                <mg-text
                  *ngIf="countdown !== 'DISABLED'"
                  variant="label-md"
                  element="p">
                  {{ countdown }}
                </mg-text>
              </div>
            </ng-container>
          </ng-template>

          <div class="tw-flex tw-justify-center tw-items-center">
            <mg-btn
              *ngIf="
                HallPassStatus.ACTIVE === hallPass.status.state || HallPassStatus.OVERDUE === hallPass.status.state
              "
              variant="text"
              id="tools-myclass-click-end"
              (pressed)="onHallPassActionClicked('end')">
              End
            </mg-btn>
            <ng-container
              *ngIf="
                HallPassStatus.PENDING_APPROVAL === hallPass.status.state &&
                (('HALL_PASS_TYPE_MANAGE' | hasPermission) || authHash === hallPass.authorPersonView?.personHash)
              ">
              <mg-btn
                variant="text"
                id="tools-myclass-click-deny"
                (pressed)="onHallPassActionClicked('deny')">
                Deny
              </mg-btn>
              <mg-btn
                variant="text"
                id="tools-myclass-click-approve"
                (pressed)="onHallPassActionClicked('approve')">
                Approve
              </mg-btn>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </mat-menu>
  </mg-tt-pill>
</ng-template>

<!-- Checkin Pill Template -->
<ng-template
  #checkinPillTemplate
  let-checkIns="checkIns">
  <mg-tt-pill
    [attr.aria-label]="'Check in Status'"
    [type]="checkIns?.length === 0 ? 'muted' : 'success'"
    [icon]="checkIns?.length === 0 ? 'mg-not-checked-in' : 'mg-checkin-menu'"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="checkin">
    <mat-menu
      #checkin="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div class="popup-wrap large tw-flex tw-flex-column tw-gap-2">
          <ng-container *ngIf="checkIns?.length > 0; else noCheckInsTemplate">
            <div
              *ngFor="let checkIn of checkIns"
              class="tw-flex tw-flex-column tw-gap-1">
              <mg-text
                variant="label-md-secondary"
                element="p">
                {{ checkIn.title }}
              </mg-text>
              <mg-text
                variant="label-md"
                element="p">
                {{ checkIn.name }}
              </mg-text>
              <mg-text
                variant="label-md"
                element="p">
                Time: {{ checkIn.checkedInAt | date: 'h:mm a' }}
              </mg-text>
            </div>
          </ng-container>
          <ng-template #noCheckInsTemplate>
            <mg-text
              variant="label-md-secondary"
              element="p">
              Not checked in
            </mg-text>
          </ng-template>
        </div>
      </ng-template>
    </mat-menu>
  </mg-tt-pill>
</ng-template>

<!-- Flextime Pill Template -->
<ng-template #flextimePillTemplate>
  <mg-tt-pill
    [attr.aria-label]="'Flextime Status'"
    [type]="upcomingFlexActivity ? 'success' : 'muted'"
    [icon]="'mg-flextime-menu'"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="flextime">
    <mat-menu
      #flextime="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div class="popup-wrap extra-large tw-flex tw-flex-column">
          <mg-text
            variant="label-md-secondary"
            element="p">
            {{ upcomingFlexActivity ? 'Upcoming activity' : 'Not registered to upcoming activity' }}
          </mg-text>
          <mg-text
            variant="label-md"
            element="p">
            Date: {{ upcomingPeriod.date | date: 'MMM d' }}
          </mg-text>
          <mg-text
            variant="label-md"
            element="p">
            Time: {{ upcomingPeriod | formatTimeRange }}
          </mg-text>
          <mg-text
            variant="label-md"
            element="p">
            Period: {{ upcomingPeriod.title }}
          </mg-text>
          <ng-container *ngIf="upcomingFlexActivity">
            <mg-text
              variant="label-md"
              element="p">
              Activity: {{ upcomingFlexActivity.flexTimeActivity?.name || '@@@@@@@@' }}
            </mg-text>
            <mg-text
              variant="label-md"
              element="p">
              Teacher: {{ upcomingFlexActivity.flexTimeActivity?.createdByPerson?.name || '@@@@@@@@' }}
            </mg-text>
            <mg-text
              variant="label-md"
              element="p">
              Location: {{ upcomingFlexActivity.flexTimeActivity?.location || '@@@@@@@@' }}
            </mg-text>
          </ng-container>
          <div
            *ngIf="!upcomingFlexActivity"
            class="tw-flex tw-justify-between tw-items-center">
            <mg-btn
              variant="text"
              size="small"
              (pressed)="flexActivityAction('assign')">
              Assign
            </mg-btn>
            <mg-btn
              variant="text"
              size="small"
              (pressed)="flexActivityAction('register')">
              Register
            </mg-btn>
          </div>
        </div>
      </ng-template>
    </mat-menu>
  </mg-tt-pill>
</ng-template>

<!-- Behavior Pill Template -->
<ng-template #praisePillTemplate>
  <mg-tt-pill
    *ngIf="(pastPraises$ | async)?.totalCount > 0 || (pastPraiseConsequences$ | async)?.totalCount > 0"
    [attr.aria-label]="'Active Praises'"
    type="success"
    [text]="(pastPraises$ | async)?.totalCount + (pastPraiseConsequences$ | async)?.totalCount"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    [matMenuTriggerFor]="pastPraises"
    (click)="$event.stopPropagation()">
    <mat-menu
      #pastPraises="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div
          class="popup-wrap"
          fxLayout="column"
          fxLayoutGap="4px">
          <div *ngIf="(pastPraises$ | async)?.totalCount > 0">
            <mg-text
              variant="label-md-secondary"
              element="p"
              >Praises</mg-text
            >
            <mg-text
              *ngFor="let praise of (pastPraises$ | async)?.items"
              variant="label-md"
              element="p">
              {{ praise.count }} {{ praise.label }}
            </mg-text>
          </div>
          <div *ngIf="(pastPraiseConsequences$ | async)?.totalCount > 0">
            <mg-text
              variant="label-md-secondary"
              element="p"
              >Consequences</mg-text
            >
            <mg-text
              *ngFor="let consequence of (pastPraiseConsequences$ | async)?.items"
              variant="label-md"
              element="p">
              {{ consequence.count }} {{ consequence.label }}
            </mg-text>
          </div>
        </div>
      </ng-template>
    </mat-menu>
  </mg-tt-pill>
</ng-template>

<!-- Guidance Pill Template -->
<ng-template #guidancePillTemplate>
  <mg-tt-pill
    *ngIf="(pastGuidances$ | async)?.totalCount > 0 || (pastConsequences$ | async)?.totalCount > 0"
    type="error"
    [attr.aria-label]="'Active Guidances'"
    [text]="(pastGuidances$ | async)?.totalCount + (pastConsequences$ | async)?.totalCount"
    [id]="'tools-myclass-click-pill-guid'"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="pastGuidances">
    <mat-menu
      #pastGuidances="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div
          class="popup-wrap"
          fxLayout="column"
          fxLayoutGap="4px">
          <div *ngIf="(pastGuidances$ | async)?.totalCount > 0">
            <mg-text
              variant="label-md-secondary"
              element="p">
              Guidances
            </mg-text>
            <mg-text
              *ngFor="let guidance of (pastGuidances$ | async)?.items; let i = index"
              variant="label-md"
              element="p">
              {{ guidance.count }} {{ guidance.label }}
            </mg-text>
          </div>
          <div *ngIf="(pastConsequences$ | async)?.totalCount > 0">
            <mg-text
              variant="label-md-secondary"
              element="p">
              Consequences
            </mg-text>
            <mg-text
              *ngFor="let consequence of (pastConsequences$ | async)?.items; let i = index"
              variant="label-md"
              element="p">
              {{ consequence.count }} {{ consequence.label }}
            </mg-text>
          </div>
        </div>
      </ng-template>
    </mat-menu>
  </mg-tt-pill>
</ng-template>

<!-- Loading Template -->
<ng-template #loadingTemplate>
  <div class="inline-spinner">
    <mg-spinner
      [diameter]="16"
      [thickness]="2">
    </mg-spinner>
  </div>
</ng-template>
